import React from 'react';

const ProjectsHeroSection = () => {
  return (
    <section aria-labelledby="projects-title" className="site-bg-hero text-center py-16 px-6">
      <h1
        id="projects-title"
        className="text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl"
      >
        Meus projetos
      </h1>
      <p className="mt-6 text-lg leading-8 text-gray-600">
        Uma coleção dos meus trabalhos, desde aplicações web até contribuições para projetos de
        código aberto.
      </p>
    </section>
  );
};

export default ProjectsHeroSection;
